import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import PopupCart from "./frontend/PopupCart";
import "./frontend.scss";



// Wait for the DOM to be ready and mount React
document.addEventListener("DOMContentLoaded", () => {

  const wrapper = document.createElement("div");
  document.body.appendChild(wrapper);
  createRoot(wrapper).render(<PopupCart />);


});